import axios from "axios";
// const ROOT_URL="https://localhost:7046/api/Reliability/"
const ROOT_URL=process.env.VUE_APP_TESTLOGIN_URL + "/reliabilityreportapi/api/Reliability/";
const GetValidatedDeviceFamiles= process.env.VUE_APP_WEB_URL + "iapps.api/api/ProductManager/GetValidatedDeviceFamiles";
const GET_CPNs = ROOT_URL + "GetReliabilityCPNDetails";
const GET_ReliabilityReportDataByCPN = ROOT_URL + "GetReliabilityReportDataByCPN";
const GET_ReliabilityCPNList = ROOT_URL + "GetReliabilityCPNList";
const GET_ReliabilityReportLabels = ROOT_URL + "GetReliabilityReportLabels";


export default{
      async GetValidatedDeviceFamiles() {
        const response = await axios.get(GetValidatedDeviceFamiles);
        return response.data;
      },
      async GetProductAutomotiveReasons() {
        const response = await axios.get(URL_GET_ProductAutomotiveReasons);
        return response.data;
      },
      // Get My PCNS
      async getAllReliabilityCPNs() {
        const response = await axios.get(GET_CPNs);
        return response.data;
      },
    
      async GetReliabilityReportDataByCPN(cpn) {
        const response = await axios.get(GET_ReliabilityReportDataByCPN, {
          params: {
            cpn: cpn
          },
        });
        return response.data;
      },
     // Get My PCNS
      async GetReliabilityReportLabels() {
      const response = await axios.get(GET_ReliabilityReportLabels);
      return response.data;
      },
    
      async GetReliabilityCPNList(srchCPN) {
        const response = await axios.get(GET_ReliabilityCPNList, {
            params: {
            srchCPN: srchCPN
            },
      });
      return response.data;
    }, 
}